import {
  FilterGroupState,
  FilterGroupActionTypes,
  GET_FILTER_GROUP_LIST,
  GET_FILTER_GROUP_LIST_FULFILLED,
  GET_FILTER_GROUP_PENDING,
  GET_FILTER_GROUP_FULFILLED,
  SELECT_FILTER_GROUP,
  CREATE_FILTER_GROUP_PENDING,
  CREATE_FILTER_GROUP_FULFILLED,
  DELETE_FILTER_GROUP_FULFILLED,
  OPEN_FILTER_GROUP_CREATE_POPUP,
  CLOSE_FILTER_GROUP_CREATE_POPUP,
  SET_FILTER_GROUP_LOADING,
} from './filterGroup.types';

export const initialState: FilterGroupState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function filterGroupReducer(
  state = initialState,
  action: FilterGroupActionTypes,
): FilterGroupState {
  switch (action.type) {
    case GET_FILTER_GROUP_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_FILTER_GROUP_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };

    case GET_FILTER_GROUP_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_FILTER_GROUP_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_FILTER_GROUP:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_FILTER_GROUP_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_FILTER_GROUP_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case DELETE_FILTER_GROUP_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case SET_FILTER_GROUP_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

      case OPEN_FILTER_GROUP_CREATE_POPUP:
        return {
          ...state,
          single: action.payload.filterGroup ?? null,
          createdId: null,
          ui: {
            ...state.ui,
            isCreatePopupOpen: true,
          },
        };

      case CLOSE_FILTER_GROUP_CREATE_POPUP:
        return {
          ...state,
          ui: {
            ...state.ui,
            isCreatePopupOpen: false,
          },
        };

    default:
      return state;
  }
}
